module.exports = __webpack_public_path__ + "static/img/comunicadRpa_AGETIC.b2c87da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comunicadRpa_AGETIC.jpg
// module id = TdGL
// module chunks = 9